import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Input } from "@/components/ui/input";

// Sep 2026 — Brand input with suggestions of existing brands. The backend
// canonicalizes casing case-insensitively, so picking a suggestion (or typing
// a variant like BROTHER) can never create a duplicate brand.
export function BrandInput({ value, onChange, testid, className }) {
  const [brands, setBrands] = useState([]);
  useEffect(() => {
    api.get("/assets/filters/values")
      .then(({ data }) => setBrands(data.brands || []))
      .catch(() => {});
  }, []);
  const listId = `brand-options-${testid || "default"}`;
  return (
    <>
      <Input
        list={listId}
        value={value || ""}
        onChange={(e) => onChange(e.target.value)}
        data-testid={testid}
        className={className}
        placeholder={brands.length ? "Pick existing or type new" : ""}
      />
      <datalist id={listId}>
        {brands.map((b) => <option key={b} value={b} />)}
      </datalist>
    </>
  );
}
